import { getField, updateField } from 'vuex-map-fields';
import helpers from '../../mixins/helpers';
import apiAxios from '../../services/apiAxios';

const state = {
    id: 0,
    clienteId: 0,
    rubroTrabajoId: 0,
    rubroTrabajo: null,
    rubroTrabajoNombre: null,
    premios: false,
    noAplicaFee: false,
    rowVersion: null,
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, params) {
        state.id = params.rubroTrabajoClienteId;
        state.clienteId = params.clienteId;

        state.rubroTrabajoId = 0;
        state.rubroTrabajo = null;
        state.rubroTrabajoNombre = null;
        state.premios = false;
        state.noAplicaFee = false;
        state.rowVersion = null;
    },
    'SET_RUBRO_TRABAJO_CLIENTE' (state, rubroTrabajoCliente) {
        state.rubroTrabajoId = rubroTrabajoCliente.rubroTrabajo.id;
        state.rubroTrabajo = rubroTrabajoCliente.rubroTrabajo;
        state.rubroTrabajoNombre = rubroTrabajoCliente.rubroTrabajo.nombre.trim();
        state.premios = (/true/i).test(rubroTrabajoCliente.premios);
        state.noAplicaFee = (/true/i).test(rubroTrabajoCliente.noAplicaFee);
        state.rowVersion = rubroTrabajoCliente.rowVersion;
    },
    'SET_RUBRO_TRABAJO' (state, rubroTrabajo) {
        state.rubroTrabajo = rubroTrabajo;
        
        if (rubroTrabajo) {
            state.rubroTrabajoId = rubroTrabajo? rubroTrabajo.id : 0;
            state.rubroTrabajoNombre = rubroTrabajo? rubroTrabajo.nombre.trim() : null;
        } else {
            state.rubroTrabajoId = 0;
            state.rubroTrabajoNombre = null;
        }
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', params);
            
            let getRubroTrabajo = false;
            if (params.rubroTrabajoClienteId) {
                if (params.rubroTrabajoClienteId != 0) {
                    getRubroTrabajo = true;
                }
            }

            if (getRubroTrabajo) {
                apiAxios.get('clientes/' + params.clienteId + '/rubros-trabajos/' + params.rubroTrabajoClienteId ) 
                .then(res => {
                    commit('SET_RUBRO_TRABAJO_CLIENTE', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();    
            }
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let rubroTrabajoCliente= {
                rubroTrabajoId: state.rubroTrabajoId,
                premios: (/true/i).test(state.premios),
                noAplicaFee: (/true/i).test(state.noAplicaFee)
            }

            let url = 'clientes/' + state.clienteId + '/rubros-trabajos';
            if (state.id != 0) {
                url += '/' + state.id;
                rubroTrabajoCliente.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, rubroTrabajoCliente)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setRubroTrabajo: ( { commit }, rubroTrabajo) => {
        commit('SET_RUBRO_TRABAJO', rubroTrabajo);
    },

    delete ( { }, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('clientes/' + params.clienteId + '/rubros-trabajos/' + params.rubroTrabajoClienteId + '/delete')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}